import React from 'react';

interface CollapseToggleProps {
  collapsed: boolean;
  onToggle: () => void;
  label?: string;
  className?: string;
}

export default function CollapseToggle({
  collapsed,
  onToggle,
  label = 'Toggle panel visibility',
  className = ''
}: CollapseToggleProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`inline-flex items-center gap-1.5 rounded-full border border-slate-900/8 bg-white/55 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.22em] text-slate-500 transition duration-150 hover:-translate-y-px hover:border-slate-900/12 hover:bg-white/80 hover:text-slate-800 dark:border-white/10 dark:bg-white/6 dark:text-slate-400 dark:hover:border-white/16 dark:hover:bg-white/10 dark:hover:text-slate-100 ${className}`}
      aria-expanded={!collapsed}
      aria-label={label}
    >
      <span className={`transition-transform duration-200 ${collapsed ? '' : 'rotate-180'}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          className="h-3.5 w-3.5"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 10.414l3.71-3.182a.75.75 0 011.04 1.08l-4.232 3.63a.75.75 0 01-.988 0l-4.232-3.63a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </span>
      <span>{collapsed ? 'Show' : 'Hide'}</span>
    </button>
  );
}
